import {ModalServicePort} from "@modules/search/suggestions/application/ports/output/ModalServicePort";

export interface ComponentDefinition {
    tagName:string;
    props: ComponentProp[];
}

interface ComponentProp {
    name:string;
    value: string;
}

export class BootstrapModalService implements ModalServicePort {

    private modalContainer: HTMLElement;
    private componentDefinition: ComponentDefinition;

    constructor(componentDefinition:ComponentDefinition) {
        this.componentDefinition = componentDefinition;
        this.modalContainer = document.querySelector('.js-bootstrap-modal-container');
    }

    open(): void {
        this.injectComponent();
        jQueryBootstrapThemeVersion('.js-bootstrap-modal-container').modal('show');
    }

    private injectComponent() {
        const componentElement: HTMLElement = document.createElement(this.componentDefinition.tagName);

        this.componentDefinition.props.forEach(({name, value}) => {
            const formattedPropName = this.formatProp(name);
            componentElement.setAttribute(formattedPropName, value);
        });

        this.modalContainer.innerHTML = '';
        this.modalContainer.appendChild(componentElement);
    }

    private formatProp(text: string) {
        const uppercaseLettersRegExp = /[A-Z]/g;
        return text.replace(uppercaseLettersRegExp, (match) => '-' + match.toLowerCase());
    }

}
